import React from "react";

import Media from "../MessageTypes/Media";
import replacePrameters from "../../helpers/replaceParameters";
import { Grid, Typography } from "@material-ui/core";
import { Info } from "@material-ui/icons";
import TouchAppIcon from "@material-ui/icons/TouchApp";

export default function TemplateMessagePreview(props) {
  const {
    parameters,
    media,
    selectedTemplate,
    maxHeight,
    bigIcon,
    showDisclaimer,
    carouselIndex,
    setCarouselIndex,
  } = props;
  const type = selectedTemplate.type;

  // Carousel: render focused card preview
  if (type === "CAROUSEL") {
    const {
      carouselTemplates = [],
      carouselButtons = [],
      carouselMediaType = "IMAGE",
      format,
    } = selectedTemplate;

    const cardIndex = carouselIndex || 0;
    const card = carouselTemplates[cardIndex] || {};
    const cardButtons = carouselButtons[cardIndex] || [];

    // Build callToAction for the focused card
    const cardCallToAction = cardButtons.map((btn) => {
      if (btn.type === "QUICK_REPLY") return { type: "QUICK_REPLY", buttonTitle: btn.text || "", buttonValue: "" };
      if (btn.type === "URL") return { type: "URL", buttonTitle: btn.text || "", buttonValue: btn.url || "" };
      if (btn.type === "PHONE_NUMBER") return { type: "Phone Number", buttonTitle: btn.text || "", buttonValue: (btn.extension || "") + (btn.number || "") };
      if (btn.type === "COPY_CODE") return { type: "COPY_CODE", buttonTitle: "Copy Code", buttonValue: btn.example || "" };
      return { type: btn.type, buttonTitle: btn.text || "", buttonValue: "" };
    });

    const cardBody = replacePrameters(card.templateFooter || "", card.parameters || []);
    const mainText = replacePrameters(format || "", parameters);

    const cardPayload = {
      text: cardBody,
      caption: cardBody,
      url: null,
      actionType: cardButtons.length > 0 ? "All" : "None",
      callToAction: cardCallToAction,
      footerText: "",
      headerText: "",
      mediaType: carouselMediaType,
    };

    const headerPayload = {
      text: mainText,
      caption: "",
      url: null,
      actionType: "None",
      callToAction: [],
      footerText: selectedTemplate.footerText || "",
      headerText: selectedTemplate.headerText || "",
    };

    return (
      <>
        {/* Main template body text */}
        <Media
          type="TEXT"
          selectedTemplate={selectedTemplate}
          payload={headerPayload}
          bigIcon={bigIcon}
          showDisclaimer={false}
        />
        {/* Focused card */}
        <Media
          type="CAROUSEL"
          selectedTemplate={selectedTemplate}
          payload={cardPayload}
          bigIcon={false}
          showDisclaimer={false}
          hideMessageTopEdge={true}
        />
      </>
    );
  }

  const text = replacePrameters(selectedTemplate.format, parameters);
  let ctaURL = selectedTemplate.templateCTAUrl;

  //For pre-existing templates
  if (!ctaURL) {
    const urlObject = (selectedTemplate.callToAction || []).filter(
      (e) => e.type === "URL"
    );

    if (urlObject.length > 0) {
      ctaURL = urlObject[0].buttonValue;
      if (parameters && parameters.length > 0) {
        const param = parameters[parameters.length - 1];
        if (param)
          ctaURL = ((string, replacement) => {
            return string.replace(/{{(\d+)}}/g, function (match, g1) {
              return `[${replacement}]`;
            });
          })(urlObject[0].buttonValue, param);
      }
    }
  }

  const payload = {
    caption: type !== "TEXT" ? text : "",
    text: type === "TEXT" ? text : "",
    url: type === "LOCATION" ? null : media.url,
    filename: type === "LOCATION" ? null : media.filename,
    latitude: type === "LOCATION" ? media?.latitude : null,
    longitude: type === "LOCATION" ? media?.longitude : null,
    locationName: type === "LOCATION" ? media?.name : null,
    address: type === "LOCATION" ? media?.address : null,
    parameters: parameters,
    actionType: selectedTemplate.actionType,
    headerText: selectedTemplate.headerText,
    footerText: selectedTemplate.footerText,
    callToAction: selectedTemplate.callToAction,
    quickReplies: selectedTemplate.quickReplies || [],
    templateCTAUrl: ctaURL,
    ...(type === "LIMITED_TIME_OFFER"
      ? {
          limitedTimeOffer: selectedTemplate.limitedTimeOffer,
          ltoButtons: selectedTemplate.ltoButtons || selectedTemplate.callToAction || [],
        }
      : {}),
  };

  return (
    <>
      <Media
        type={selectedTemplate.type}
        selectedTemplate={selectedTemplate}
        payload={payload}
        maxHeight={maxHeight}
        bigIcon={bigIcon}
        showDisclaimer={showDisclaimer}
      />
    </>
  );
}
